import { AddressSuggestion } from "types";

export interface GetAddressSuggestionsResponse extends Response {
  suggestions?: Array<AddressSuggestion>;
}

export const getAddressSuggestions = async (
  input: string,
): Promise<GetAddressSuggestionsResponse> => {
  const encodedInput = encodeURIComponent(input);
  return await fetch(
    `https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest?text=${encodedInput}&category=Address&countryCode=USA,CAN&f=json&maxSuggestions=5`,
    {
      method: "GET",
      redirect: "follow",
    },
  );
};
